import React from 'react';
import PropTypes from 'prop-types';

function AlreadyMemberBlock({setRoute}) {
  return (
    <p className="switchIdentification">
      Déjà membre Clevermate ?{' '}
      <a
        href="#"
        className="link-red"
        onClick={ev => {
          ev.preventDefault();
          setRoute('connexion', 'reset');
        }}
      >
        Connexion
      </a>
    </p>
  )
}

AlreadyMemberBlock.propTypes = {
  setRoute: PropTypes.func.isRequired,
};

export default AlreadyMemberBlock;